import React, {
  ReactNode,
  useEffect,
  useMemo,
  useState,
  HTMLProps,
} from "react";

import SearchComponent from "../../../components/dashboard-components/SearchComponent";
import _ from "lodash";
import { useUserStore } from "../../../store/useUser";
import UsersModal from "../../../components/dashboard-components/users/UsersModal";
import { useInvitation } from "../../../sevices/hooks/users";
import InvitationTable from "../../../components/invitation_table";
import { useSearchParams } from "react-router-dom";

export interface InvitationsFilters {
  page: number;
  pageSize: number;
  //   currency?: string;
  //   date?: string;
  //   fromDate?: string;
  //   toDate?: string;
  email?: string;
}

const Invitations = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const setUserDetailsModal = useUserStore((state) => state.setShowUserDetails);
  const showUserDetailsModal = useUserStore((state) => state.showUserDetails);

  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState(
    searchParams.get("search") || ""
  );

  // Create a debounced search function
  const debouncedSearch = useMemo(
    () =>
      _.debounce((term: string) => {
        setSearchTerm(term);
        setPage(1); // Reset to first page when searching

        // Update URL params to reflect search state
        const params = new URLSearchParams(searchParams);
        if (term) {
          params.set("search", term);
        } else {
          params.delete("search");
        }
        params.set("page", "1");
        setSearchParams(params);
      }, 500),
    [searchParams, setSearchParams]
  );

  // Apply search term changes
  const handleSearch = (value: string) => {
    debouncedSearch(value);
  };

  // Update URL when page changes
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    const params = new URLSearchParams(searchParams);
    params.set("page", newPage.toString());
    setSearchParams(params);
  };

  // Fetch invitations with proper parameters
  const { data: invitationsData, isLoading } = useInvitation({
    page,
    pageSize,
    email: searchTerm.trim() || undefined,
  });

  return (
    <>
      <div className="h-100vh w-full bg-[#FEFEFF] p-5 md:pr-5 md:pl-8">
        <div className="flex flex-row items-center justify-between mt-5">
          <h1 className="font-bold text-2xl text-[#071827] md:pb-2">
            Invitations
          </h1>
        </div>

        <div className="mb-4">
          <SearchComponent
            placeholder="Search by email"
            onSearch={handleSearch}
            // initialValue={searchTerm}
          />
        </div>

        <div>
          <InvitationTable
            data={invitationsData?.data?.data}
            isLoading={isLoading}
            page={page}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      {showUserDetailsModal && (
        <UsersModal
          isOpen={showUserDetailsModal}
          onClose={setUserDetailsModal} refetchTable={undefined}        />
      )}
    </>
  );
};

export default Invitations;
export function IndeterminateCheckbox({
  indeterminate,
  className = "",
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = React.useRef<HTMLInputElement>(null!);

  React.useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={className + " cursor-pointer h-4 w-4 text-gray-500"}
      {...rest}
    />
  );
}

export const truncateUserID = (userID: string) => {
  // Truncate the userID to a certain length
  const maxLength = 20;
  return userID.length > maxLength
    ? `${userID.slice(0, maxLength)}...`
    : userID;
};
